import axios from 'axios'
import {
  StockCompanyResponse
} from '@/types/api'

const baseUrl = `${process.env.VUE_APP_API_URL_BASE}/stockCompany`

export default {
  // 証券会社名一覧検索API
  search (params: {companyName: string}): Promise<StockCompanyResponse[]> {
    return new Promise((resolve, reject) => {
      axios.get(`${baseUrl}`, { params })
        .then(({ data }: { data: StockCompanyResponse[] }) => {
          resolve(data)
        }).catch((errors) => {
          reject(errors)
        })
    })
  }

}
